import { useSelector } from 'react-redux';
import { editorLeftSidebarModel, LeftSidebarOptions } from '../model';
import { CallsTab, RecordsTab, SnippetsTab, TemplatesTab } from './components';
import { ConversionsTab } from './components/conversions';
import { ElementsTab } from './components/elements';
import { SettingsTab, TemplateSettingsTab } from './components/settings';
import { templatesModel } from '../../templates';
import { NarrationTab } from './components/narration';

export const EditorLeftSidebarContent = () => {
  const selectedOption = useSelector(
    editorLeftSidebarModel.selectors.selectSidebarOption
  );

  const currentPageOrTemplate = useSelector(
    editorLeftSidebarModel.selectors.selectCurrentPageOrTemplateWithError
  );

  const isTemplateMode = Boolean(
    useSelector(templatesModel.selectors.selectCurrentTemplate)
  );

  return (
    <>
      {selectedOption === LeftSidebarOptions.TEMPLATES && <TemplatesTab />}
      {selectedOption === LeftSidebarOptions.CONVERSIONS && (
        <ConversionsTab currentPageOrTemplate={currentPageOrTemplate} />
      )}
      {selectedOption === LeftSidebarOptions.ELEMENTS && <ElementsTab />}
      {!isTemplateMode && selectedOption === LeftSidebarOptions.SETTINGS && (
        <SettingsTab />
      )}
      {isTemplateMode && selectedOption === LeftSidebarOptions.SETTINGS && (
        <TemplateSettingsTab />
      )}
      {selectedOption === LeftSidebarOptions.SNIPPETS && <SnippetsTab />}
      {selectedOption === LeftSidebarOptions.VIDEOS && <RecordsTab />}
      {selectedOption === LeftSidebarOptions.CALLS && <CallsTab />}
      {selectedOption === LeftSidebarOptions.NARRATION && <NarrationTab />}
    </>
  );
};
